'use client';

import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';
import useLocalStorage from '@/hooks/useLocalStorage';
import { gameQueryOptions } from '@/queries/games/games.queries';
import { SEARCH_QUERY_ALLOWED_CHARS_REGEX } from '../../consts/recentSearchRegex';
import DesktopSearchDropdown from './components/DesktopSearchDropdown';
import MobileSearchDropdown from './components/MobileSearchDropdown';

interface Props {
  searchValue: string;
  inputValue: string;
  isFocused: boolean;
  blurSearchInput: () => void;
}

const GamesFiltered = ({
  searchValue,
  inputValue,
  isFocused,
  blurSearchInput,
}: Props) => {
  const [recentSearch, setRecentSearch] = useLocalStorage<string>('recentSearch', '');
  const isMobile = useIsMobile();

  const { data: gamesData, isLoading: isLoadingGames } = useQuery(gameQueryOptions.list({
    params: {
      page: 1,
      limit: isMobile ? 9 : 8,
      filters: searchValue ? { name: searchValue.toLowerCase() } : undefined,
    },
    options: { enabled: searchValue !== '' },
  },
  ));

  const shouldRenderDropDown = isFocused || Boolean(inputValue);
  const gameList = gamesData?.items || [];

  const setLastRecentSearch = useCallback(() => {
    if (!inputValue || inputValue.length < 3 || !SEARCH_QUERY_ALLOWED_CHARS_REGEX.test(inputValue)) {
      return;
    }

    setRecentSearch(inputValue);
  }, [inputValue, setRecentSearch]);

  useEffect(() => {
    if (gamesData?.items?.length && gamesData.items.length > 0) {
      setLastRecentSearch();
    }
  }, [searchValue, gamesData]);

  if (!shouldRenderDropDown) {
    return null;
  }

  return (
    <>
      {isMobile
        ? <MobileSearchDropdown blurSearchInput={blurSearchInput} isLoadingGames={isLoadingGames} gameList={gameList} searchValue={searchValue} isFocused={isFocused} recentSearch={recentSearch} />
        : <DesktopSearchDropdown isLoadingGames={isLoadingGames} searchValue={searchValue} gameList={gameList} recentSearch={recentSearch} />}
    </>
  );
};

export default GamesFiltered;
